(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('impact-auto-cart-recommendations')) {
  customElements.define('impact-auto-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.load(this.controller.signal).catch(error => {
        if (error.name !== 'AbortError') console.warn('[Impact cart recommendations]', error);
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    async load(signal) {
      const excluded = new Set(this.dataset.cartProducts.split(',').filter(Boolean));
      const chosen = new Map();
      const parser = new DOMParser();
      for (const intent of ['complementary', 'related']) {
        for (const productId of excluded) {
          if (signal.aborted || !this.isConnected) return;
          const url = new URL(this.dataset.url, window.location.origin);
          url.search = new URLSearchParams({ section_id: this.dataset.sectionId, product_id: productId, limit: '10', intent }).toString();
          try {
            const response = await fetch(url, { signal, credentials: 'same-origin' });
            if (!response.ok) {
              console.warn('[Impact cart recommendations] HTTP', response.status);
              continue;
            }
            const doc = parser.parseFromString(await response.text(), 'text/html');
            const candidates = doc.querySelector('template[data-auto-cart-candidates]');
            if (!candidates) continue;
            for (const card of candidates.content.querySelectorAll('template[data-auto-cart-product]')) {
              const id = card.dataset.autoCartProduct;
              if (!excluded.has(id) && !chosen.has(id)) chosen.set(id, card);
              if (chosen.size === 2) break;
            }
          } catch (error) {
            if (signal.aborted) return;
            console.warn('[Impact cart recommendations]', error);
          }
          if (chosen.size === 2) break;
        }
        if (chosen.size === 2) break;
      }
      if (!chosen.size || signal.aborted || !this.isConnected) return;
      const layout = this.querySelector('template[data-auto-cart-layout]').content.cloneNode(true);
      const insertion = layout.querySelector('template[data-auto-cart-insertion]');
      for (const card of chosen.values()) {
        const fragment = card.content.cloneNode(true);
        const direct = fragment.querySelector('template[data-auto-cart-direct-add]');
        const cta = fragment.querySelector('.horizontal-product__cta');
        if (direct && cta) cta.replaceChildren(direct.content.cloneNode(true));
        direct?.remove();
        insertion.before(fragment);
      }
      insertion.remove();
      this.hidden = false;
      this.replaceChildren(layout);
    }
  });
}

if (!customElements.get('dw-cart-quantity-tools')) {
  customElements.define('dw-cart-quantity-tools', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.querySelectorAll('line-item-quantity input[data-line-key]').forEach(input => {
          if (input.closest('quantity-selector')) return;
          const placeholder = document.createComment('');
          input.replaceWith(placeholder);
          const selector = document.createElement('quantity-selector');
          selector.className = 'quantity-selector dw-cart-quantity';
          const decrease = document.createElement('button');
          decrease.type = 'button';
          decrease.className = 'quantity-selector__button';
          decrease.setAttribute('aria-label', 'Aantal verlagen');
          decrease.textContent = '−';
          const increase = document.createElement('button');
          increase.type = 'button';
          increase.className = 'quantity-selector__button';
          increase.setAttribute('aria-label', 'Aantal verhogen');
          increase.textContent = '+';
          selector.append(decrease, input, increase);
          placeholder.replaceWith(selector);
          const updateLimits = () => {
            const value = Number(input.value);
            const min = Number(input.min || 1);
            const step = Number(input.step || 1);
            decrease.disabled = value - step < min;
            increase.disabled = input.max !== '' && value + step > Number(input.max);
          };
          input.addEventListener('change', updateLimits);
          updateLimits();
        });
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
